import React, { useState } from "react"
import Swiper from "react-id-swiper"
import tw from "twin.macro"
import styled from "@emotion/styled"
import { ChevronRight, ChevronLeft } from "react-feather"

interface Props {
  children: React.ReactNode

  className?: string
  leftArrow?: React.ElementType
  rightArrow?: React.ElementType

  [x: string]: any
}

export const RightArrow = (props: Record<string, any>) => (
  <StyledRightArrow.Wrapper>
    <StyledRightArrow.Button aria-label="next slide" {...props}>
      <StyledRightArrow.SVG />
    </StyledRightArrow.Button>
  </StyledRightArrow.Wrapper>
)

const StyledRightArrow = {
  Wrapper: tw.div`absolute inset-0 flex items-center justify-end transition-opacity duration-150 ease-in-out sm:opacity-0`,
  Button: styled.button`
    ${tw`relative flex items-center justify-center w-8 mr-4 focus:outline-none hover:text-gray-700 after:content after:absolute after:bg-white after:rounded-full after:p-4 after:shadow`}

    z-index: 2;

    &::after {
      z-index: -1;
    }
  `,
  SVG: tw(ChevronRight)`transition-colors duration-200 ease-in-out`,
}

export const LeftArrow = (props: Record<string, any>) => (
  <StyledLeftArrow.Wrapper>
    <StyledLeftArrow.Button aria-label="previous slide" {...props}>
      <StyledLeftArrow.SVG />
    </StyledLeftArrow.Button>
  </StyledLeftArrow.Wrapper>
)

const StyledLeftArrow = {
  Wrapper: tw.div`absolute inset-0 flex items-center transition-opacity duration-150 ease-in-out sm:opacity-0`,
  Button: styled.button`
    ${tw`relative flex items-center justify-center w-8 ml-4 focus:outline-none hover:text-gray-700 after:content after:absolute after:bg-white after:rounded-full after:p-4 after:shadow`}

    z-index: 2;

    &::after {
      z-index: -1;
    }
  `,
  SVG: tw(ChevronLeft)`transition-colors duration-200 ease-in-out`,
}

export const Carousel: React.FC<Props> = ({
  children,
  className,
  leftArrow: LeftArrow,
  rightArrow: RightArrow,
  ...props
}) => {
  const [swiper, setSwiper] = useState(null)

  if (!children) {
    console.warn("Carousel must have children.")
    return null
  }

  const nextSlide = () => {
    if (swiper) {
      swiper.slideNext()
    }
  }

  const previousSlide = () => {
    if (swiper) {
      swiper.slidePrev()
    }
  }

  return (
    <Wrapper className={className}>
      {LeftArrow && (
        <LeftArrow data-testid="carousel-left-arrow" onClick={previousSlide} />
      )}
      <Swiper getSwiper={setSwiper} {...props}>
        {children as any}
      </Swiper>
      {RightArrow && (
        <RightArrow data-testid="carousel-right-arrow" onClick={nextSlide} />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${tw`relative`}

  &:hover {
    /* Left arrow */
    & > *:nth-of-type(1) {
      ${tw`opacity-100`}
    }
    /* Right arrow */
    & > *:nth-of-type(3) {
      ${tw`opacity-100`}
    }
  }
`
